import { useRef } from 'react';
import { FileInput, Button, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Upload from '@/assets/images/upload.svg?react'; // eslint-disable-line import/no-unresolved

const CustomFileInput = ({
  label, placeholder, onChange, value, helperText, accept = '.pdf', ...props
}) => {
  const fileInputRef = useRef(null);
  const { t } = useTranslation();

  return (
    <>
      <FileInput
        ref={fileInputRef}
        label={label}
        placeholder={placeholder}
        accept={accept}
        value={value}
        onChange={onChange}
        required
        mb="md"
        rightSection={
          <Button
            rightSection={<Upload size={18} />}
            onClick={() => fileInputRef.current?.click()}
          >
            {t('pages.mortgageCycle.bankFileUpload.fileUpload.button.upload')}
          </Button>
        }
        {...props}
      />
      <Text size="sm" c='#525E6F'>
        {helperText}
      </Text>
    </>
  );
};

CustomFileInput.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.instanceOf(File),
  onChange: PropTypes.func,
  accept: PropTypes.string,
  helperText: PropTypes.string,
};

export default CustomFileInput;
